export default "__VITE_ASSET__cc323677__"